export const getButtonTapEventData = (event) => {
  const buttonOrder = event.currentTarget.dataset.order
  const buttonText = event.currentTarget.textContent

  return { buttonOrder, buttonText }
}
